import { Database } from '@/types/supabase-types';

// Define the correct type using the database schema
type EmployeeRow = Database['ShiftSage']['Tables']['employees']['Row'];

interface OverviewTabContentProps {
  employee: Pick<
    EmployeeRow,
    'id' | 'email' | 'created_at' // Keep ID, email and add created_at (as potential hire date)
  >;
}

export function OverviewTabContent({ employee }: OverviewTabContentProps) {
  // Format created_at date safely
  const joinedDate = employee.created_at 
    ? new Date(employee.created_at).toLocaleDateString()
    : 'N/A';

  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-6">
        <div className="space-y-1">
          <p className="text-sm text-muted-foreground">Employee ID</p>
          {/* Ensure ID is treated as string for padStart */}
          <p className="font-medium">EMP-{String(employee.id).padStart(3, '0')}</p> 
        </div>
        
        <div className="space-y-1">
          <p className="text-sm text-muted-foreground">Email</p>
          <p className="font-medium">{employee.email}</p>
        </div>
        
        <div className="space-y-1">
          <p className="text-sm text-muted-foreground">Joined Date</p>
          <p className="font-medium">{joinedDate}</p> 
        </div>
      </div>
    </div>
  )
}
